/* eslint-disable */

import React, { useEffect, useState } from "react";
import styled from "styled-components";
import GlobalStyles from "../Styles/Index";
import { PrimaryButton } from "../Button/Index";
import { Colors } from "../../assets/Res/Colors";
import ProfileIcon from "../../assets/Icons/user.svg";
import GreenDotIcon from "../../assets/Icons/green_dot.svg";
import GreyDotIcon from "../../assets/Icons/grey_dot.svg";
import GreenLineIcon from "../../assets/Icons/green_line.svg";
import GreyLineIcon from "../../assets/Icons/grey_line.svg";
import GreenVLineIcon from "../../assets/Icons/green_vertical_line.svg";
import GreyVLineIcon from "../../assets/Icons/grey_vertical_line.svg";
import { APIProvider, Map, Marker, useMap } from "@vis.gl/react-google-maps";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import { Box } from "@mui/material";
import { IconIMG } from "../Images/Index";
import { formatDate } from "../../utils";

const TrackWrapper = styled.div`
  width: 80%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 5vh 10% 5vh 10%;

  @media (max-width: 1400px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin: 0px;
  }
`;

const Track = ({ loading, packageDetails }) => {

  return (
    <>
      <TrackWrapper>
        <TrackMap loading={loading}
          packageDetails={packageDetails} />
        <TrackDetails loading={loading}
          packageDetails={packageDetails} />
      </TrackWrapper>
    </>
  );
};

const TrackMapWrapper = styled.div`
  width: 48%;
  height: fit-content;

  @media (max-width: 1400px) {
    width: 100%;
  }
`;
const TrackIDWrapper = styled.div`
100%;
`;

const HeadText = styled.div`
  font-family: Helvetica;
  font-size: 1.7rem;
  text-align: left;
  width: 65%;
  padding: 5px 0px 5px 0px;

  @media (max-width: 1400px) {
    width: 100%;
  }
`;

const TrackMapHeader = styled.div`
  width: 60%;

  @media (max-width: 1400px) {
    width: 100%;
  }
`;

const NormalText = styled.div`
  font-family: Helvetica;
  font-size: 1rem;
  text-align: left;
  opacity: 0.5;
  padding: 5px 0px 5px 0px;
`;

const MapScreen = styled.div`
  width: 100%;
  height: 70vh;
  border-bottom-right-radius: 30px;
  margin-top: 5vh;
  font-family: Helvetica
`;

const TrackMap = ({ loading, packageDetails }) => {

  const origin = { lat: -33.860664, lng: 151.208138 };
  const destination = { lat: -33.865143, lng: 151.2099 };

  const mapStyles = [
    {
      featureType: "all",
      elementType: "labels",
      stylers: [{ visibility: "off" }], // Hide all labels
    },
    {
      featureType: "poi",
      elementType: "all",
      stylers: [{ visibility: "off" }], // Hide Points of Interest
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: [{ visibility: "simplified" }], // Simplify road appearance
    },
    {
      featureType: "transit",
      elementType: "all",
      stylers: [{ visibility: "off" }], // Hide public transport lines
    },
  ];

  const DirectionsComponent = () => {
    const map = useMap();

    useEffect(() => {
      if (!map) return;

      const directionsService = new google.maps.DirectionsService();
      const directionsRenderer = new google.maps.DirectionsRenderer({
        map,
        suppressMarkers: true,
        polylineOptions: { strokeColor: Colors.RED.PRIMARY, strokeWeight: 4 },
      });

      directionsService.route(
        {
          origin,
          destination,
          travelMode: google.maps.TravelMode.DRIVING,
        },
        (result, status) => {
          if (status === google.maps.DirectionsStatus.OK) {
            directionsRenderer.setDirections(result);
          } else {
            console.error("Directions request failed:", status);
          }
        }
      );
    }, [map]);

    return null;
  };
  return (
    <>
      <TrackMapWrapper>
        {loading ? <Box display="flex" flexDirection="row" gap={1} width="100%">
          <Skeleton variant="circular" width={70} height={70} />
          <Stack spacing={1} width={"50%"}>
            <Skeleton variant="rectangular" width="100%" height={40} />
            <Skeleton variant="rounded" width="80%" height={20} />
          </Stack>
        </Box> : <TrackMapHeader>
          <TrackIDWrapper style={{ ...GlobalStyles.HorizontalFlex }}>
            <HeadText>{packageDetails?.order?._package?.trackingID || "---"}</HeadText>
            <PrimaryButton
              text={packageDetails?.order?.deliveryStatus || "Unavailable"}
              bgColor={packageDetails?.order?.deliveryStatus === "Pending" ? Colors.FAINT_RED : Colors.FAINT_GREEN}
              color={packageDetails?.order?.deliveryStatus === "Pending" ? Colors.RED : Colors.GREEN}
              width={"30%"}
              padding={"5px"}
            />
          </TrackIDWrapper>
          <NormalText>
            Live track your parcel or contact your courier
          </NormalText>
        </TrackMapHeader>}

        {loading ?
          <Stack spacing={1} width={"100%"} height={'70vh'} marginTop={'5vh'}>
            <Skeleton variant="rectangular" width={"100%"} height={50} />
            <Skeleton variant="rectangular" width={"80%"} height={30} />
            <Skeleton variant="rectangular" width={"70%"} height={15} />
          </Stack> : <MapScreen>
            <APIProvider
              apiKey={"AIzaSyDjlzl7BgpBBfpvCigr9PxloilmLdynBsg"}
              onLoad={() => console.log("Maps API has loaded.")}
            >
              {packageDetails?.driver?.details ? <Map
                mapOptions={{
                  disableDefaultUI: true,
                  styles: mapStyles,
                }}
                defaultZoom={14}
                defaultCenter={origin}
                onCameraChanged={(ev) =>
                  console.log(
                    "camera changed:",
                    ev.detail.center,
                    "zoom:",
                    ev.detail.zoom
                  )
                }
                mapId={"8159df05f9f9337e"}
              >
                <Marker position={origin} />
                <Marker position={destination} />
                <DirectionsComponent />
              </Map> :
                <MapScreen style={{ ...GlobalStyles.VerticalFlex }}>
                  Live Tracking Unavailable
                </MapScreen>}
            </APIProvider>
          </MapScreen>}

      </TrackMapWrapper>
    </>
  );
};

const TrackDetailsWrapper = styled.div`
  width: 48%;
  height: fit-content;

  @media (max-width: 1400px) {
    width: 100%;
  }
`;

const TrackDetailHeader = styled.div`
  background-color: #fafafa;
  border-radius: 15px;
  padding: 10px;

  @media (max-width: 1400px) {
  }
`;

const HeadProfileWrapper = styled.div`
  width: 100%;
  height: 8vh;

  @media (max-width: 1400px) {
    flex-direction: column;
    height: fit-content;
    align-items: flex-start;
    justify-content: flex-start;
  }
`;

const VerticalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  width: 75%;
  height: 5vh;

  @media (max-width: 1400px) {
    width: 90%;
    margin-left: ${(props) => (props.null ? props.null : "13%")};
  }
`;
const BoldText = styled.div`
  font-family: Helvetica;
  font-size: 0.8rem;
  font-weight: 600;
  padding: 5px 0px 5px 0px;
`;

const LightText = styled.div`
  font-family: Helvetica;
  font-size: 0.7rem;
  opacity: 0.5;
  padding: 5px 0px 5px 0px;
`;

const SimpleWrapper = styled.div`
  width: 40%;

  @media (max-width: 1400px) {
    width: 100%;
  }
`;

const TrackBody = styled.div`
  background-color: ${Colors.YELLOW};
  border-radius: 20px;
  padding: 10px 30px 10px 30px;
  margin-top: 5vh;
  height: 70vh;

  @media (max-width: 1400px) {
    height: fit-content;
  }
`;

const DetailsHead = styled.div`
  width: 100%;

  @media (max-width: 1400px) {
    flex-direction: column;
    align-items: left;
    justify-content: left;
  }
`;

const DetailsTable = styled.div`
  width: 100%;
  background-color: #ffffff;
  border-radius: 15px;
  height: 65%;
`;

const StateTrackerWrapper = styled.div`
  width: 100%;
  background-color: #ffffff;
  border-radius: 15px;
  height: 20%;
  margin-top: 2vh;

  @media (max-width: 1400px){
    padding: 20px 10px 20px 10px;
  }
`;

const DetailsFields = styled.div`
  width: 90%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 3% 5% 3% 5%;
`;
const DetailsText = styled.div`
  font-family: Helvetica;
  font-size: 1rem;
  opacity: 0.6;
`;

const DesktopWrapper = styled.div`
  width: 90%;
  padding: 5px 5% 5px 5%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${(props) => (props.justify ? props.justify : "center")};

  @media (max-width: 1400px) {
    display: none;
  }
`;

const MobileWrapper = styled.div`
  display: none;

  @media (max-width: 1400px) {
    width: ${(props) => (props.width ? props.width : "100%")};
    display: flex;
    flex-direction: ${(props) => (props.direction ? props.direction : "row")};
    justify-content: ${(props) =>
    props.justify ? props.justify : "space-between"};
    align-items: ${(props) => (props.align ? props.align : "flex-start")};
    padding: 0px 10px 0px 10px;
  }
`;

const TextWrapperMobile = styled.div`
  width: 90%;
  font-family: Helvetica;
  font-size: 1rem;
`;

const TrackDetails = ({ loading, packageDetails }) => {
  return (
    <>
      <TrackDetailsWrapper>
        {loading ? <Box display="flex" flexDirection="row" gap={1} width="100%">
          <Skeleton variant="circular" width={70} height={70} />
          <Stack spacing={1} width={"80%"}>
            <Skeleton variant="rectangular" width="100%" height={40} />
            <Skeleton variant="rounded" width="80%" height={20} />
          </Stack>
        </Box> : <TrackDetailHeader style={{ ...GlobalStyles.HorizontalFlex }}>
          <HeadProfileWrapper style={{ ...GlobalStyles.HorizontalFlex }}>
            <SimpleWrapper style={{ ...GlobalStyles.HorizontalFlex }}>
              <IconIMG icon={ProfileIcon} width={"50px"} height={"50px"} />
              <VerticalWrapper null={true}>
                <BoldText>{packageDetails?.driver?.details?.account?.fullName || "----"}</BoldText>
                <LightText>Driver</LightText>
              </VerticalWrapper>
            </SimpleWrapper>
            <SimpleWrapper>
              <VerticalWrapper>
                <LightText>Email Address</LightText>
                <BoldText>{packageDetails?.driver?.details?.account?.email || "----"}</BoldText>
              </VerticalWrapper>
            </SimpleWrapper>
            <SimpleWrapper>
              <VerticalWrapper>
                <LightText>phone number</LightText>
                <BoldText>{packageDetails?.driver?.details?.account?.phoneNumber?.numberCode || "----"}</BoldText>
              </VerticalWrapper>
            </SimpleWrapper>
          </HeadProfileWrapper>
        </TrackDetailHeader>}

        {loading ? <Stack spacing={1} width={"100%"} height={'70vh'} marginTop={'5vh'}>
          <Skeleton variant="rectangular" width="100%" height={150} />
          <Skeleton variant="rounded" width="80%" height={50} />
          <Skeleton variant="rounded" width="60%" height={30} />
        </Stack> : <TrackBody>
          <DetailsHead style={{ ...GlobalStyles.HorizontalFlex }}>
            <HeadText>Order Information</HeadText>
            <PrimaryButton
              text={"Edit Details"}
              color={"#1C1C1C"}
              bgColor={"#FFFFFF"}
              width={"20%"}
              smallWidth={"100%"}
            />
          </DetailsHead>
          <NormalText>
            Your delivery package and current information about your parcels
          </NormalText>
          <DetailsTable>
            <DetailsFields>
              <DetailsText>Package</DetailsText>
              <DetailsText style={{ width: "70%" }}>
                {packageDetails?.order?._package?.name || "----"}
              </DetailsText>
            </DetailsFields>
            <DetailsFields>
              <DetailsText>Full name</DetailsText>
              <DetailsText style={{ width: "70%" }}>
                {packageDetails?.order?.reciever?.name || "----"}
              </DetailsText>
            </DetailsFields>
            <DetailsFields>
              <DetailsText>Phone</DetailsText>
              <DetailsText style={{ width: "70%" }}>
                {packageDetails?.order?.reciever?.phone || "----"}
              </DetailsText>
            </DetailsFields>
            <DetailsFields>
              <DetailsText>Total Payment</DetailsText>
              <DetailsText style={{ width: "70%" }}>${packageDetails?.order?.quote?.cost || "----"}</DetailsText>
            </DetailsFields>
            <DetailsFields>
              <DetailsText>Order date</DetailsText>
              <DetailsText style={{ width: "70%" }}>
                {packageDetails?.createdAt ? formatDate(packageDetails?.createdAt) : "----"}
              </DetailsText>
            </DetailsFields>
            <DetailsFields>
              <DetailsText>Delivery date</DetailsText>
              <DetailsText style={{ width: "70%" }}>
                {packageDetails?.createdAt ? formatDate(packageDetails?.createdAt) : "----"}
              </DetailsText>
            </DetailsFields>
            <DetailsFields>
              <DetailsText>Location</DetailsText>
              <DetailsText style={{ width: "70%" }}>
                {packageDetails?.order?.reciever ? packageDetails?.order?.reciever?.address || `${packageDetails?.order?.reciever?.pickCenter}, ${packageDetails?.order?.reciever?.country}` : "----"}
              </DetailsText>
            </DetailsFields>
            <DetailsFields>
              <DetailsText>Courier</DetailsText>
              <DetailsText style={{ width: "70%" }}>
                {packageDetails?.driver?.details?.account?.fullName || "---"}
              </DetailsText>
            </DetailsFields>
          </DetailsTable>
          {packageDetails?.trackingInfo &&
            packageDetails?.trackingInfo.length > 0 ?
            <StateTrackerWrapper>
              <DesktopWrapper justify={"space-between"}>
                <DetailsText>{packageDetails?.trackingInfo[0].head}</DetailsText>
                <DetailsText>{packageDetails?.trackingInfo[2].head}</DetailsText>
                <DetailsText>{packageDetails?.trackingInfo[4].head}</DetailsText>
              </DesktopWrapper>
              <DesktopWrapper>
                <IconIMG icon={packageDetails?.trackingInfo[0].isDone ? GreenDotIcon : GreyDotIcon} width={"15px"} height={"15px"} />
                <IconIMG icon={packageDetails?.trackingInfo[2].isDone ? GreenLineIcon : GreyLineIcon} width={"200px"} height={"50px"} />
                <IconIMG icon={packageDetails?.trackingInfo[2].isDone ? GreenDotIcon : GreyDotIcon} width={"15px"} height={"15px"} />
                <IconIMG icon={packageDetails?.trackingInfo[4].isDone ? GreenLineIcon : GreyLineIcon} width={"200px"} height={"50px"} />
                <IconIMG icon={packageDetails?.trackingInfo[4].isDone ? GreenDotIcon : GreyDotIcon} width={"15px"} height={"15px"} />
              </DesktopWrapper>
              <DesktopWrapper>
                <DetailsText style={{ fontSize: "0.7rem" }}>
                  Note: Indicator above shows the route of which the transit took,
                  this is generated based on the tracking ID you searched for. For
                  more information please contact your courier agent or shipping
                  agency
                </DetailsText>
              </DesktopWrapper>
              <MobileWrapper>
                <MobileWrapper
                  direction={"column"}
                  justify={"center"}
                  align={"center"}
                  width={"5%"}
                >
                  <IconIMG icon={packageDetails?.trackingInfo[0].isDone ? GreenDotIcon : GreyDotIcon} width={"15px"} height={"15px"} />
                  <IconIMG
                    icon={packageDetails?.trackingInfo[0].isDone ? GreenVLineIcon : GreyVLineIcon}
                    // width={"5px"}
                    height={"100px"}
                  />
                </MobileWrapper>
                <TextWrapperMobile>
                  <DetailsText>{packageDetails?.trackingInfo[0].head}</DetailsText>
                  <DetailsText>{packageDetails?.trackingInfo[0].content}</DetailsText>
                </TextWrapperMobile>
              </MobileWrapper>
              <MobileWrapper>
                <MobileWrapper
                  direction={"column"}
                  justify={"center"}
                  align={"center"}
                  width={"5%"}
                >
                  <IconIMG icon={packageDetails?.trackingInfo[2].isDone ? GreenDotIcon : GreyDotIcon} width={"15px"} height={"15px"} />
                  <IconIMG
                    icon={packageDetails?.trackingInfo[2].isDone ? GreenVLineIcon : GreyVLineIcon}
                    // width={"5px"}
                    height={"100px"}
                  />
                </MobileWrapper>
                <TextWrapperMobile>
                  <DetailsText>{packageDetails?.trackingInfo[2].head}</DetailsText>
                  {/* <DetailsText>Left Carlifornia at 4pm</DetailsText> */}
                </TextWrapperMobile>
              </MobileWrapper>
              <MobileWrapper>
                <MobileWrapper
                  direction={"column"}
                  justify={"center"}
                  align={"center"}
                  width={"5%"}
                >
                  <IconIMG icon={packageDetails?.trackingInfo[4].isDone ? GreenDotIcon : GreyDotIcon} width={"15px"} height={"15px"} />
                </MobileWrapper>
                <TextWrapperMobile>
                  <DetailsText>{packageDetails?.trackingInfo[4].head}</DetailsText>
                  <DetailsText>{packageDetails?.trackingInfo[4].content}</DetailsText>
                </TextWrapperMobile>
              </MobileWrapper>
            </StateTrackerWrapper> : <></>}
        </TrackBody>}
      </TrackDetailsWrapper>
    </>
  );
};

export default Track;
